import dynamic from 'next/dynamic';

type ClientOnlyProps = { children: JSX.Element };
const OnlyClient = (props: ClientOnlyProps) => {
  const { children } = props;

  return children;
};

export default dynamic(() => Promise.resolve(OnlyClient), {
  ssr: false,
});
